import React from "react";
import { Flex } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import { RelatorioInadimplentesItem } from "core/features/relatorios/typings/index";
import { Row, Col } from "antd";

interface TableTotalRowProps {
  item: RelatorioInadimplentesItem;
}

function TableTotalRow({ item }: TableTotalRowProps) {
  return (
    <Flex as={Row} gutter={4} w="100%">
      <Flex as={Col} xs={7}>
        <Flex ml={"46px"}>Total</Flex>
      </Flex>
      <Flex as={Col} xs={2} />
      <Flex as={Col} xs={1} />
      <Flex as={Col} xs={2} justifyContent="flex-end">
        <Flex>{formatMoney(item.totalPrincipal)}</Flex>
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(item.totalMulta)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(item.totalJuros)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(item.totalTaxaCobranca)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(item.totalCorrecaoMonetaria)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        --
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(item.total)}
      </Flex>
    </Flex>
  );
}

export default TableTotalRow;
